import React from 'react';

export default function CRPBlockWrapper({children, title}) {
  
  return (
    <div className='blockWrapper'>
      <div className='blockTitle'>{title}</div>
      <div className='content'>{children}</div>
    </div>
  )
}